import { useEffect, useState } from "react";
import { logError } from "../logging/logger";

// https://github.com/disposable/disposable?tab=readme-ov-files
const useDisposableDomains = () => {
  const [domains, setDomains] = useState<string[]>([]);

  useEffect(() => {
    const fetchDomains = async () => {
      try {
        const response = await fetch(
          "https://rawcdn.githack.com/disposable/disposable-email-domains/master/domains.json",
        );
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        setDomains(data);
      } catch (error) {
        logError(`Failed to fetch disposable domains: ${error}`);
      }
    };

    fetchDomains();
  }, []);
  return domains;
};

const useBlockedDomains = () => {
  const [domains, setDomains] = useState<string[]>([]);

  useEffect(() => {
    // this will be set from backend call in future
    setDomains(["fthcapital.com", "hameatfirst.xyz"]);
  }, []);
  return domains;
};

export { useDisposableDomains, useBlockedDomains };
